import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import { MatxLoading } from 'app/components';
import { useGetLoginMutation, useGetProfileMutation } from 'services/RtkServices';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useMsal } from '@azure/msal-react';

const initialState = {
  user: null,
  isInitialised: false,
  isAuthenticated: false,
  errorMsg: '',
  isError: false
};

// const isValidToken = (accessToken) => {
//   if (!accessToken) return false;

//   const decodedToken = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decodedToken.exp > currentTime;
// };

// const setSession = (accessToken) => {
//   if (accessToken) {
//     localStorage.setItem('accessToken', accessToken);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//   } else {
//     localStorage.removeItem('accessToken');
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT': {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isAuthenticated, isInitialised: true, user, errorMsg: '', isError: false };
    }
    case 'LOGIN': {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user, errorMsg: '', isError: false };
    }
    case 'ERROR': {
      const { msg } = action.payload;
      return {
        ...state,
        isAuthenticated: false,
        errorMsg: msg,
        isError: true,
        isInitialised: true
      };
    }
    case 'LOGOUT': {
      return { ...state, isAuthenticated: false, user: null };
    }
    case 'CLOSE-MODAL': {
      return {
        ...state,
        isAuthenticated: false,
        errorMsg: '',
        isError: false,
        isInitialised: true
      };
    }
    case 'REGISTER': {
      const { user } = action.payload;

      return { ...state, isAuthenticated: true, user };
    }

    default:
      return state;
  }
};

const AuthContext = createContext({
  ...initialState,
  method: 'JWT',
  login: () => {},
  logout: () => {},
  register: () => {},
  updateError: () => {},
  closeErrorModal: () => {}
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [getProfile] = useGetProfileMutation();
  const [getLogin] = useGetLoginMutation();
  const location = useLocation();
  const { hash, pathname, search } = location;
  const { instance, inProgress, accounts } = useMsal();
  const login = async (values) => {
    try {
      // const response = await axios.post('/api/auth/login', { email, password });
      // const { user } = response.data;
      let payload = {
        userType: values.usertype,
        userid: values.email,
        password: values.password
      };
      return await getLogin(payload);

      // dispatch({ type: 'LOGIN', payload: { user } });
    } catch (error) {
      console.log('error---->', error);
    }
  };
  const register = async (email, username, password) => {
    const response = await axios.post('/api/auth/register', { email, username, password });
    const { user } = response.data;

    dispatch({ type: 'REGISTER', payload: { user } });
  };

  const logout = () => {
    dispatch({ type: 'LOGOUT' });
    localStorage.clear();
    instance.logout();
  };
  const closeErrorModal = () => {
    dispatch({ type: 'CLOSE-MODAL' });
  };

  useEffect(() => {
    const getUser = async () => {
      try {
        // const { data } = await axios.get('/api/auth/profile');
        let payload = {
          usertype: await localStorage.getItem('login_type')
        };
        const { data } = await getProfile(payload);
        console.log('data----->', data);
        if (data.statusCode === 200) {
          dispatch({
            type: 'INIT',
            payload: { isAuthenticated: true, user: data.adminUserDataResposne }
          });
          window.location.reload();
        }
        // else if (data.statusCode === 401) {
        //   // logout();
        // }
        else if (data.statusCode === 404) {
          dispatch({ type: 'ERROR', payload: { msg: data?.responseMessage } });
          Swal.fire({
            icon: 'error',
            title: data?.responseMessage
            // text: data?.responseMessage
          });
        }
      } catch (err) {
        console.log('error---->', err);
        logout();
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      }
    };

    getUser();
  }, [pathname]);

  console.log('state==>', state);
  // SHOW LOADER
  if (!state.isInitialised) return <MatxLoading />;

  return (
    <AuthContext.Provider
      value={{ ...state, method: 'JWT', login, logout, register, closeErrorModal }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
